import styled from 'styled-components';

// Axis label font sizes
export const FONT_SIZE_AXIS = 11;

// chart opacity
export const OPACITY_100 = '100%';
export const OPACITY_40 = '40%';
export const OPACITY_10 = '10%';

// colors
export const COLOR_IMPORT = '#e6c644cc';
export const COLOR_IMPORT_UNTRADED = '#f0e7dbcc';
export const COLOR_EXPORT = '#3bb667cc';
export const COLOR_EXPORT_UNTRADED = '#f7f2eccc';
export const COLOR_STROKE = '#e6e6e9';
export const COLOR_LABEL = '#6b6b76';

// other constants
// not used for UI, but used in statements's conditions, in keys of data object
// or programmatic entities as opposed to language information at this stage.
export const BAR_RATIO = 0.9;
export const CHART_HEIGHT = 240;
export const TICK_COUNT = 10;
export const IMPORTS = 'Imports';
export const EXPORTS = 'Exports';
export const METER = 'meter';
export const TRADE = 'trade';
export const BUY = 'buy';
export const SELL = 'sell';
export const UNIT_CURRENCY = 'UNIT_CURRENCY';
export const UNIT_CURRENCY_FORMAT = '$.5~s';
export const UNIT_CURRENCY_AXIS_FORMAT_SMALL_VALUE = '$.3~f';
export const UNIT_CURRENCY_TOOLTIP_FORMAT_SMALL_VALUE = '$.3f';
export const UNIT_CURRENCY_TOOLTIP_FORMAT_LARGE_VALUE = '$.2f';
export const UNIT_CURRENCY_TOOLTIP_FORMAT_LARGE_VALUE_THRESHOLD = 10;
export const UNIT_CURRENCY_KEY = 'value';
export const UNIT_CURRENCY_LABEL = '$';
export const UNIT_ENERGY = 'UNIT_ENERGY';
export const UNIT_ENERGY_FORMAT = '~s';
export const UNIT_ENERGY_KEY = 'volume';
export const UNIT_ENERGY_LABEL = 'Wh';
export const Y_AXIS_DOMAIN_MULTIPLIER = 1.05;
export const UNIT_CARBON = 'UNIT_CARBON';
export const UNIT_CARBON_KEY = 'carbon';
export const UNIT_CARBON_DEFAULT_LABEL = 'kg CO2-e';
export const UNIT_CARBON_TOOLTIP_FORMAT = '.3f';

export const KILO_GRAM = 'kg';
export const GRAM = 'g';
export const TONNE = 't';
export const KILO_TONNE = 'kt';
export const MEGA_TONNE = 'mT';
export const CARBON_EMISSION = 'CO2-e';

export const ChartAxisStyle = {
  axis: { stroke: COLOR_STROKE },
  axisLabel: {
    fill: COLOR_LABEL,
    fontFamily: 'inherit',
    fontSize: FONT_SIZE_AXIS,
  },
  ticks: { stroke: COLOR_STROKE, size: 3 },
  tickLabels: {
    fill: COLOR_LABEL,
    fontFamily: 'inherit',
    fontSize: FONT_SIZE_AXIS,
    padding: 2,
  },
};

export const chartPadding = {
  top: 20, bottom: 20, right: 20, left: 50,
};

export const carbonProps = {
  key: UNIT_CARBON_KEY,
  label: UNIT_CARBON_DEFAULT_LABEL,
  format: UNIT_ENERGY_FORMAT,
  tooltipFormat: UNIT_CARBON_TOOLTIP_FORMAT,
};

export const currencyProps = {
  key: UNIT_CURRENCY_KEY,
  label: '', // label comes from the d3 format
  format: UNIT_CURRENCY_FORMAT,
  tooltipFormat: UNIT_CURRENCY_TOOLTIP_FORMAT_SMALL_VALUE,
};

export const energyProps = {
  key: UNIT_ENERGY_KEY,
  label: UNIT_ENERGY_LABEL,
  format: UNIT_ENERGY_FORMAT,
};

// Styles
const base = 2.5;

export const SectionWrapper = styled.div`
font-size: ${base * 0.3}rem;
`;

export const SectionHeader = styled.h6`
font-size: ${base * 0.3}rem;
margin-bottom: ${base * 0.1}rem;
`;

export const SectionContainer = styled.div`
max-width: 200px;
margin-bottom: ${base * 0.2}rem;
`;

// End of styles
// Time constants in milliseconds for date/time calculations
export const DURATION_P1D_MS = 24 * 60 * 60 * 1000;
export const DURATION_PT30M_MS = 30 * 60 * 1000;
export const FALLBACK_BAR_WIDTH = 3;
